import { Icon } from 'ui';
import React from 'react';

const HeaderCustom = ({ left, center, right, className, onClose }) => {
  return (
    <div className={`header-custom ${className ? className : ''}`}>
      <div className="header-custom__grid">
        <div className="header-custom__left">{left}</div>
        <div className="header-custom__center">{center}</div>
        <div className="header-custom__right">
          {right}
          {onClose && (
            <div className="header-close__close" onClick={onClose}>
              <Icon name="close" size="big" color="black" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderCustom;
